import recommend from '@algolia/recommend';
import algoliasearch from 'algoliasearch/lite';
import axios from 'axios';

import { getLastSeenProductIdsStorage } from '@jsmdg/browser-storage';
import { createFragment } from '@jsmdg/react-fragment-scripts/fragment';
import { Brand, Tenant } from '@jsmdg/tenancy';
import { type FragmentContext } from '../shared/types';
import { Recommendations } from './components/Recommendations';
import { fetchProducts } from './services/fetchProducts';

// eslint-disable-next-line @typescript-eslint/require-await
async function initDependencies({ baseUrl }: { baseUrl?: string }): Promise<void> {
    axios.defaults.baseURL = baseUrl;
}

const { Fragment, init } = createFragment(
    Recommendations,
    ({
        tenant,
        locale,
        rootComponentProps: {
            initialWishlist,
            customerState,
            wishlistEnabled,
            algoliaConfig,
            pageType,
            tenantConfig,
            locationFilter,
            featureFlagsVariation,
        },
    }): FragmentContext => ({
        locale,
        tenant,
        getLastSeenProductIdsStorage,
        customerState,
        initialWishlist,
        wishlistEnabled,
        algoliaConfig,
        locationFilter,
        recommendClient: recommend(algoliaConfig.appId, algoliaConfig.searchKey),
        searchClient: algoliasearch(algoliaConfig.appId, algoliaConfig.searchKey),
        pageType,
        tenantConfig,
        isMydays: new Tenant(tenant).belongsTo(Brand.Mydays),
        featureFlagsVariation,
        fetchProducts,
    }),
    initDependencies,
);

export { Fragment, init };
